// components
import Image from 'next/image';

// utilities
import { getImagePath } from '@/utils/images';
import VisibleLoading from '@/components/utilities/VisibleLoading';

const ImageBoxBlock = ({ image, imageBoxVariant: variant, imageBoxLights: lights }) => {
  if (!image) {
    return null;
  }

  return (
    <div className="relative">
      <VisibleLoading>
        {({ ref, className }) =>
          variant === 'border' ? (
            <Image
              ref={ref}
              src={getImagePath(image)}
              width={image.width}
              height={image.height}
              alt={image.alternativeText}
              className={`border-white-75 relative z-2 mx-auto max-h-[640px] w-full min-w-[200px] rounded-3xl border border-8 object-cover ${className || ''}`.trim()}
            />
          ) : (
            <Image
              ref={ref}
              src={getImagePath(image)}
              width={image.width}
              height={image.height}
              alt={image.alternativeText}
              className={`relative z-2 mx-auto min-w-[200px] rounded-3xl shadow-xl/15 ${className || ''}`.trim()}
            />
          )
        }
      </VisibleLoading>

      {lights === 'variant1' ? (
        <>
          <VisibleLoading delay={500} opacity={30}>
            {({ ref, className }) => (
              <div
                ref={ref}
                className={`absolute -right-[15%] -bottom-[25%] z-1 h-[405px] w-[405px] transform-gpu rounded-full bg-yellow-500 blur-[150px] ${className || ''}`.trim()}
              />
            )}
          </VisibleLoading>

          <VisibleLoading delay={500} opacity={30}>
            {({ ref, className }) => (
              <div
                ref={ref}
                className={`absolute -top-[25%] -left-[15%] z-1 h-[300px] w-[300px] transform-gpu rounded-full bg-yellow-500 blur-[150px] ${className || ''}`.trim()}
              />
            )}
          </VisibleLoading>
        </>
      ) : lights === 'variant2' ? (
        <>
          <VisibleLoading delay={500} opacity={50}>
            {({ ref, className }) => (
              <div
                ref={ref}
                className={`absolute -top-[25%] -right-[15%] z-1 h-[470px] w-[470px] transform-gpu rounded-full bg-purple-500 blur-[150px] ${className || ''}`.trim()}
              />
            )}
          </VisibleLoading>

          <VisibleLoading delay={500} opacity={40}>
            {({ ref, className }) => (
              <div
                ref={ref}
                className={`bg-brand-500 absolute -top-[20%] -left-[15%] z-1 h-[330px] w-[330px] transform-gpu rounded-full blur-[150px] ${className || ''}`.trim()}
              />
            )}
          </VisibleLoading>

          <VisibleLoading delay={500} opacity={50}>
            {({ ref, className }) => (
              <div
                ref={ref}
                className={`absolute -bottom-[20%] left-[15%] z-1 h-[330px] w-[330px] transform-gpu rounded-full bg-yellow-500 blur-[150px] ${className || ''}`.trim()}
              />
            )}
          </VisibleLoading>
        </>
      ) : null}
    </div>
  );
};
export default ImageBoxBlock;
